import axios from 'axios';
import { useAppSettings } from 'context/appsettingsContext';
import { useAuth } from 'context/useAuth';
import { useEffect, useState } from 'react';
import { useCollection } from './useCollection';
import { where } from 'firebase/firestore';
import { mapToClientInterface } from './useGetUsers';
import { NotificationMap } from './useGetUsers';

export interface ClientInterface {
  email: string;
  firstName: string;
  id: string;
  idNumber: string;
  lastName: string;
  phoneCode: string;
  phoneNumber: string;
  totalNumberOfVehicles?: number;
  idNumberIsSouthAfrican?: boolean;
  createdOnDateTime: string;
  tamperActive: boolean;
  auraDisabled: boolean;
  threeDtPackage: string;
  notification: NotificationMap;
}

export default function useGetCompanyUsers(companyId: string, filters?: string, orderBy?: string, pageSize?: number, pageIndex?: number) {
  const { authorisedUser } = useAuth();
  const settings = useAppSettings();

  const [users, setUsers] = useState<ClientInterface[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const usersCollection = useCollection<any>('users');

  useEffect(() => {
    let cancelled = false;
    async function getUsers() {
      if (settings?.baseURL) {
        
        setLoading(true);

        console.log('URL', URL);

        try {
          
          const users = (await usersCollection.queryMany([where("companyIds", "array-contains", companyId)])).map(x => mapToClientInterface(x));

          if (cancelled) return;
          setUsers(users);

        } catch (error) {
          if (cancelled) return;
          if (axios.isAxiosError(error)) {
            setError(error.message);
          }
        } finally {
          if (!cancelled) {
            setLoading(false);
            sortUsers('');
          }
        }
      }
    }
    getUsers();
    return () => { cancelled = true; };
  }, [authorisedUser.accessToken, companyId, filters, orderBy, pageSize, pageIndex, settings.baseURL]);

  function sortUsers(label: string) {
    switch (label) {
      case 'A - Z':
        setUsers((prevState) => {
          return prevState.sort((a, b) =>
            a.firstName.localeCompare(b.firstName)
          );
        });
        break;
      case 'Z - A':
        setUsers((prevState) => {
          return prevState.sort((a, b) =>
            b.firstName.localeCompare(a.firstName)
          );
        });
        break;
      case 'Active Alerts':
        setUsers((prevState) => {
          return prevState.sort((a, b) =>
            a.tamperActive < b.tamperActive ? 1 : -1
          );
        });
        break;
      default:
        setUsers((prevState) => {
          return prevState.sort((a, b) =>
            b.createdOnDateTime.localeCompare(a.createdOnDateTime)
          );
        });
    }
  }

  return {
    users,
    loading,
    error,
    sortUsers,
  };
}